import React from 'react'

import { SxProps } from '@mui/material'
import { TResource } from 'types/GlobalResource'

import AvatarGroup from 'components_new/molecules/AvatarGroup'

import { useTranslation } from 'language/translator'

interface Props {
  resources: TResource[]
  onClick?: () => void
  sx?: SxProps
}

const ResourcesChip = React.memo((props: Props) => {
  const { resources, onClick, sx } = props

  const { t } = useTranslation()

  // success
  return (
    <AvatarGroup
      emptyIcon={{ name: 'Resources' }}
      items={resources.map((r) => ({
        avatar: r.variant,
        id: r.id,
        title: r.title
      }))}
      onClick={onClick}
      tooltip={`${t('global', 'show')} ${t('global', 'resources', true)}`}
      sx={sx}
    />
  )
})

export default ResourcesChip
